var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"user-list mt-3",attrs:{"fluid":""}},[_c('v-row',{staticClass:"ma-0"},[_c('v-col',{attrs:{"cols":"12"}},[_c('h1',[_vm._v("Vendors page")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }